import { render, staticRenderFns } from "./SubscriptionCourseWatchDuration.vue?vue&type=template&id=26c51999&"
import script from "./SubscriptionCourseWatchDuration.vue?vue&type=script&lang=js&"
export * from "./SubscriptionCourseWatchDuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports